import React, { Component, createRef } from "react";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faArrowRightLong, faListCheck, faPen, faTrash, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import moment from "moment";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import ProductionRMSlipModel from "../../components/production/ProductionRMSlip.js";
import Breadcrumb from "../component/Breadcumb.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class ProductionRequisition extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.productionServices = new ProductionServices();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      tableStatus: "",
      isLoading: false,
      isGridView: true,
      isQtyEditing: false,
      isPrintButtonHide: false,
      isQtyEditingKey: null,
      setRMSlipModel: false,
      liquidWeight: 0,
      solidWeight: 0,
      productDropdownList: [],
      productionRequisitionList: [],
      rmFormulaList: [],
      filterDetails: {
        partyName: "",
        productName: "",
        filterBy: "",
        productionStageId: [2],
      },
      filterByList: [
        { filterBy: "Prod.No.", value: "productionNo" },
        { filterBy: "Prod.Date", value: "productionPlanningDate" },
        { filterBy: "Batch No", value: "batchNo" },
      ],
      productionTypeList: [
        // { type: "Production Planning", value: 1 },
        { type: "Production Requisition", value: 2 },
        { type: "Packing Requisition", value: 3 },
        { type: "Pending Batches", value: 4 },
      ],
      updatedQty: 0,
      productionRequisition: {
        productDetialsId: "",
        productionNo: "",
        batchNo: "",
        batchSize: "",
        stdBatchSize: "",
        productId: "",
        mfgDate: "",
        expDate: "",
        expiryMonth: "",
        size: "",
        colour: "",
        productNote: "",
        productionStageStatusId: 0,
        productName: '',
      },
      validationRules: {
        productionNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "slip no"
            ),
          },
        ],
        batchNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch no"
            ),
          },
        ],
        batchSize: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch size"
            ),
          },
        ],
        // stdBatchSize: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.SelectRequired.replace(
        //       "{0}",
        //       "std. batch size"
        //     ),
        //   },
        // ],
        productId: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        mfgDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "mfg. date"
            ),
          },
        ],
        expDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "exp. date"
            ),
          },
        ],
        // size: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "size"
        //     ),
        //   },
        // ],
        // colour: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "colour"
        //     ),
        //   },
        // ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllProductionPlanningEntry();
  }

  getAllProductionPlanningEntry = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices
      .getAllProductionPlanningEntry(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let res = response.responseData;
          if (res.length === 0) {
            this.setState({ noItemFound: "No Records Found" });
          }
          this.setState({ productionRequisitionList: res }, () => {
            this.getAllProductDropdown();
          });
        } else {
          this.setState({ tableStatus: "" })
          this.getAllProductDropdown();
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  getAllProductDropdown = () => {
    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems }, () => {
          //   this.getAllPackingMaterialDropdown();
        });
      } else {
        // this.getAllPackingMaterialDropdown();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.productionRequisition,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  getProductionPlanningEntryById = (id) => {
    this.productionServices
      .getProductionPlanningEntryById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = this.state.productionRequisition;
          let res = response.responseData;
          details.productionNo = res.productionNo;
          details.batchNo = res.batchNo;
          details.batchSize = res.batchSize;
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productId = res.productId ? res.productId._id : "";
          details.productName = res.productId ? res.productId.productName : "";
          details.size = res.productId ? res.productId.sizeName : "";
          details.colour = res.productId ? res.productId.color : "";
          details.productDetialsId = res._id ? res._id : "";
          details.mfgDate = res.mfgDate
            ? moment(res.mfgDate).format("yyyy-MM-DD")
            : "";
          details.expiryMonth = res.productId.expiryMonth
          details.expDate = res.expDate
            ? moment(res.expDate).format("yyyy-MM-DD")
            : "";
          details.productionRequisitionReqDate = res.productionRequisitionReqDate
            ? moment(res.productionRequisitionReqDate).format("yyyy-MM-DD")
            : "";
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productionStageStatusId =
            res.productionStageStatusId.productionStageId;
          details.productNote = res.productNote !== '' ? res.productNote : res.productId.productNote;

          this.setState({ productionRequisition: details }, () => {
            if (this.state.productionRequisition.productionStageStatusId >= 3 || res.isRMFormulaCreated === true) {
              this.getProductionRMFOrmulaByProductionDetailsId(
                this.state.productionRequisition.productDetialsId
              );
            } else {
              this.getRMFormulaForProductionById(
                this.state.productionRequisition.productId
              );
            }
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  removeProductionPlanningEntryFromProductionRequisition = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete?`
    ).then((response) => {
      if (response === true) {
        this.productionServices.removeProductionPlanningEntryFromProductionRequisition(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.getAllProductionPlanningEntry()
            this.SwalServices.Success(response.Message)
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    })
  }

  getProductionRMFOrmulaByProductionDetailsId = (id) => {
    this.productionServices
      .getProductionRMFOrmulaByProductionDetailsId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let array = response.responseData;
          // array.map((product) => {
          //   product.isEditing = false;
          //   product.netQty = (Number(product.netQty) * (Number(this.state.productionRequisition.batchSize) ? this.state.productionRequisition.batchSize : 1)).toFixed(3)
          //   product.totalStock = Number(product.totalStock).toFixed(3)
          // });
          this.setState({ rmFormulaList: array, isGridView: false }, () => {
            this.calculateTotalWeight(this.state.rmFormulaList)
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  getRMFormulaForProductionById = (id) => {
    this.productionServices
      .getRMFormulaForProductionById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let array = response.responseData;
          array.map((product) => {
            product.isEditing = false;
            product.netQty = (
              (Number(product.netQty) / Number(product.batchSize > 0 ? product.batchSize : 1))
              *
              (Number(this.state.productionRequisition.batchSize) ? this.state.productionRequisition.batchSize : 1)
            ).toFixed(3);
            product.totalStock = Number(product.totalStock).toFixed(3);
          });
          this.setState({ rmFormulaList: array, isGridView: false }, () => {
            this.calculateTotalWeight(this.state.rmFormulaList)
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  calculateTotalWeight = (items) => {
    let solidWeight = 0;
    let liquidWeight = 0;

    items.forEach(({ netQty, rmUOM, stageName }) => {
      const quantity = parseFloat(netQty) || 0;

      if (stageName !== 'COATING') {
        switch (rmUOM?.toUpperCase()) {
          // Solid weights (convert to KGS)
          case 'KGS':
            solidWeight += quantity;
            break;
          case 'GM':
            solidWeight += quantity / 1000;
            break;
          case 'MG':
            solidWeight += quantity / 1_000_000;
            break;
          case 'MCG':
            solidWeight += quantity / 1_000_000_000;
            break;

          // Liquid weights (convert to LTR)
          case 'LTR':
            liquidWeight += quantity;
            break;
          case 'ML':
            liquidWeight += quantity / 1000;
            break;

          default:
            console.warn(`Unknown UOM: ${rmUOM}`);
        }
      }
    });

    this.setState({
      solidWeight: solidWeight.toFixed(2) + ' KGS',
      liquidWeight: liquidWeight.toFixed(2) + ' LTR'
    });
  };



  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllProductionPlanningEntry();
      });
    } else {
      let details = this.state.productionRequisition;
      details[name] = value.toUpperCase();
      this.setState({ productionRequisition: details });
    }
  };
  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.productDetails;
    details[drpIdentity] = selected.value;
    this.setState({ productionRequisition: details });
  };

  handleDropDownChange = (e, name) => {
    const select = e.target.value;
    let details = this.state.filterDetails;
    if (name === 'productionStageId') {
      details.productionStageId = [Number(select)]
    } else {
      details[name] = select;
    }
    this.setState({ filterDetails: details }, () => {
      this.getAllProductionPlanningEntry();
    });

  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let filterDetails = this.state.filterDetails;
    filterDetails.partyName = "";
    filterDetails.productName = "";
    filterDetails.filterBy = "";
    // filterDetails.productionStageId = [2];
    let details = this.state.productionRequisition;
    details.productionNo = "";
    details.batchNo = "";
    details.batchSize = "";
    details.productId = "";
    details.mfgDate = "";
    details.expDate = "";
    details.size = "";
    details.colour = "";
    this.setState({ filterDetails: filterDetails, productDetails: details, isQtyEditing: false, validState: validState, tableStatus: "" }, () => {
      this.getAllProductionPlanningEntry();
    });
  };

  editQtyForRMFormula = () => {
    this.setState({ isQtyEditing: true });
  };

  handleQtyChange = (event) => {
    let value = event.target.value;
    this.setState({ updatedQty: value });
  };

  updateQtyForRMFormula = (item, index) => {
    const itemList = [...this.state.rmFormulaList];
    itemList[index] = {
      ...itemList[index],
      netQty: Number(this.state.updatedQty),
    };
    this.setState(
      { rmFormulaList: itemList, isQtyEditing: false, isQtyEditingKey: null }, () => {
        this.calculateTotalWeight(this.state.rmFormulaList);
      });
  };

  generateSlipForProductionRequisition = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let itemList = this.state.rmFormulaList;
        let isValidStock = !itemList.some(
          (item) => Number(item.netQty) > Number(item.totalStock)
        );
        if (isValidStock) {
          this.addEditProductionPlanningEntry();
        } else {
          this.SwalServices.Alert("Please check your stock");
          this.setState({ isLoading: false })
        }
      })
    }
  };

  addEditProductionPlanningEntry = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      let request = this.state.productionRequisition;
      if (request.productDetialsId === "") {
        delete request.productDetialsId;
      }
      request.productionStageId = 3;
      request.isRMFormulaCreated = true;
      if (request.productionRequisitionReqDate === '' || request.productionRequisitionReqDate === null || request.productionRequisitionReqDate === undefined) {
        request.productionRequisitionReqDate = new Date()
      }
      this.productionServices
        .addEditProductionPlanningEntry(request)
        .then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.productionRequisitionRMFormulaListing();

          } else {
            this.productionRequisitionRMFormulaListing();
            this.SwalServices.Error(
              response.Message
            );
          }
        });
    }
  };

  productionRequisitionRMFormulaListing = () => {
    let request = {};
    request.rmFormulaArray = this.state.rmFormulaList;
    request.rmFormulaArray.map((x) => {
      x.productDetialsId = this.state.productionRequisition.productDetialsId;
    });
    request.productId = this.state.productionRequisition.productId;
    request.productDetialsId = this.state.productionRequisition.productDetialsId;
    this.productionServices
      .productionRequisitionRMFormulaListing(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData !== null) {
          let details = this.state.productionRequisition
          details.productName = this.state.productDropdownList.find((party) => party.value === this.state.productionRequisition.productId).label
          this.setState({ productionRequisition: details })
          this.setState({ setRMSlipModel: true, isLoading: false }, () => {
            this.getAllProductionPlanningEntry()
            this.setState({ isGridView: true });
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
          this.setState({ isLoading: false })
        }
      });
  };

  setOpenModel = () => {
    this.setState({ setRMSlipModel: !this.state.setRMSlipModel });
  };

  printData = () => {
    // this.setState({ isPrintButtonHide: true }, () => {
    //   window.print();
    //   this.setState({ setRMSlipModel: false, isPrintButtonHide: false });
    // });

    const printContent = this.printRef.current;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();

    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  handleChangeForDatePicker = (date, name) => {
    let details = this.state.productionRequisition;
    details[name] = date;
    if (name === 'mfgDate') {
      let expiryMonth = details.expiryMonth ? details.expiryMonth : 0
      let expDate = moment(date).add(expiryMonth - 1, 'months').toDate();
      details.expDate = expDate;
    }
    this.setState({ productionRequisition: details });
  }


  render() {
    const activePage = 'Production Requisition';
    return (
      <>
        <div className="productionRequisition-page">
          {this.state.isGridView === true ? (
            <>
              {/* <Breadcrumb page={activePage} /> */}
              <div className='flex gap-[8px] items-center mb-[8px]'>
                {/* <div className="h-[20px] w-[20px]"><FontAwesomeIcon icon={faListCheck} style={{ height: "100%", width: "100%", }} /></div> */}
                {/* <img
                  src="clipboard.png"
                  alt="A placeholder image"
                /> */}
                <p className='text-lg font-bold text-gray-700'>Production Requisition</p>
              </div>
              <div className="item-search mb-4">
                <div className="item-grp grid grid-cols-4 gap-2.5">
                  {/* <div className="search-grp">
                    <label>Party Name:</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="party-name"
                      name="partyName"
                      autoComplete="off"
                      value={this.state.filterDetails.partyName}
                      onChange={(event) =>
                        this.handleChange(event, "partyName", "filterDetails")
                      }
                    />
                  </div> */}
                  <div className="search-grp">
                    <label>Product Name:</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="product-name"
                      name="productName"
                      autoComplete="off"
                      value={this.state.filterDetails.productName}
                      onChange={(event) =>
                        this.handleChange(event, "productName", "filterDetails")
                      }
                    />
                  </div>
                  <div className="search-grp">
                    <label>Filter By:</label>
                    <select
                      name="filterBby"
                      value={this.state.filterDetails.filterBy}
                      onChange={(event) =>
                        this.handleDropDownChange(
                          event,
                          "filterBy",
                          "filterDetails"
                        )
                      }
                    >
                      <option>Select</option>
                      {this.state.filterByList.map((x, key) => (
                        <option key={key} value={x.value}>
                          {x.filterBy}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="search-grp">
                    <label>Production Stage:</label>
                    <select
                      name="filterBby"
                      value={this.state.filterDetails.productionStageId}
                      onChange={(event) =>
                        this.handleDropDownChange(
                          event,
                          "productionStageId",
                          "filterDetails"
                        )
                      }
                    >
                      {this.state.productionTypeList.map((x, key) => (
                        <option key={key} value={x.value}>
                          {x.type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="itemList-table">
                <div className="table-container" style={{ height: 'calc(100vh - 160px)' }}>
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: "10%" }}>Prod.No</td>
                        <td style={{ width: "10%" }}>Prod.Date</td>
                        {/* <td style={{ width: "15%" }}>Party Name</td> */}
                        <td style={{ width: "20%" }}>Product Name</td>
                        <td style={{ width: "10%" }}>Batch No</td>
                        <td style={{ width: "10%" }}>Batch Size</td>
                        <td style={{ width: "15%" }}>Status</td>
                        <td style={{ width: "10%", textAlign: "center" }}>
                          Action
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.productionRequisitionList &&
                        this.state.productionRequisitionList.length > 0
                        ? this.state.productionRequisitionList.map(
                          (item, key) => (
                            <tr key={key}>
                              <td>{item.productionNo}</td>
                              <td>
                                {item.productionPlanningDate
                                  ? moment(
                                    item.productionPlanningDate
                                  ).format("DD MMM yyyy")
                                  : ""}
                              </td>
                              {/* <td>
                                {item.partyId?.partyName
                                  ? item.partyId.partyName
                                  : ""}
                              </td> */}
                              <td>
                                {item.productId?.productName
                                  ? item.productId?.productName
                                  : ""}
                              </td>
                              <td>{item.batchNo}</td>
                              <td>{item.batchSize}</td>
                              <td>
                                {
                                  item.productionStageStatusId
                                    .productionStageName
                                }
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {/* <button
                                  className="add-btn gap-1.25 !w-fit !h-fit !py-1.25 !px-[8px] leading-normal"
                                  onClick={() =>
                                    this.getProductionPlanningEntryById(
                                      item._id
                                    )
                                  }
                                >
                                  Proceed
                                  <FontAwesomeIcon icon={faArrowRightLong} />
                                </button> */}
                                <button
                                  className="search-btn"
                                  onClick={() =>
                                    this.getProductionPlanningEntryById(
                                      item._id
                                    )
                                  }
                                  title="Edit"
                                >
                                  <FontAwesomeIcon icon={faPen} />
                                </button>
                                {item.productionStageStatusId.productionStageId === 2 ?
                                  <button
                                    className="cancel-btn"
                                    onClick={() => this.removeProductionPlanningEntryFromProductionRequisition(item._id)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                  : null}
                              </td>
                            </tr>
                          )
                        )
                        : this.state.productionRequisitionList &&
                          this.state.productionRequisitionList.length === 0
                          && this.state.tableStatus !== "" ? (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                              {this.state.tableStatus}
                            </td>
                          </tr>
                        ) : this.state.productionRequisitionList &&
                          this.state.productionRequisitionList.length === 0
                          && this.state.tableStatus === "" ? null : ""}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : null}

          {this.state.isGridView === false ? (
            <div className="item-form">
              <span
                className="text-lg font-bold mb-[10px] text-gray-700"
              >
                Production Requisition
              </span>
              <div className="form-table">
                <div className="item-grp grid grid-cols-5 gap-2.5 mb-3">
                  <div className="input-grp w-full">
                    <label>Prod. No</label>
                    <input
                      id="productionNo"
                      type="text"
                      name="productionNo"
                      autoComplete="off"
                      disabled
                      value={this.state.productionRequisition.productionNo}
                      onChange={(event) =>
                        this.handleChange(event, "productionNo")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.productionNo}
                    /> */}
                  </div>
                  <div className="input-grp w-full">
                    <label>Batch No</label>
                    <input
                      type="text"
                      id="batchNo"
                      name="batchNo"
                      autoComplete="off"
                      disabled
                      value={this.state.productionRequisition.batchNo}
                      onChange={(event) => this.handleChange(event, "batchNo")}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.batchNo}
                    /> */}
                  </div>
                  <div className="input-grp w-full">
                    <label>Batch Size</label>
                    <input
                      type="number"
                      id="batchSize"
                      name="batchSize"
                      autoComplete="off"
                      disabled
                      value={this.state.productionRequisition.batchSize}
                      onChange={(event) =>
                        this.handleChange(event, "batchSize")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.batchSize}
                    /> */}
                  </div>
                  <div className="input-grp col-span-2">
                    <label>Product Name</label>
                    <MultiSelectDropdown
                      drpIdentity="productId"
                      options={this.state.productDropdownList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "productId")
                      }
                      allowSelectAll={false}
                      value={this.state.productDropdownList.filter(
                        (party) =>
                          party.value ===
                          this.state.productionRequisition.productId
                      )}
                      isDisabled={true}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.productId}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Mfg. Date</label>
                    <DatePicker
                      selected={this.state.productionRequisition.mfgDate}
                      className={`inputFocus ${this.state.validState?.error?.mfgDate ? "errorInput" : ""}`}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      onChange={(date) => this.handleChangeForDatePicker(date, "mfgDate")}
                      disabled={this.state.productionRequisition.productionStageStatusId >= 3}
                    />
                    {/* <ValidationText error={this.state.validStateForMaterials.error.mfgDate} /> */}
                  </div>
                  <div className="input-grp">
                    <label>Exp. Date</label>
                    <DatePicker
                      selected={this.state.productionRequisition.expDate}
                      className={`inputFocus ${this.state.validState?.error?.expDate ? "errorInput" : ""}`}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      onChange={(date) => this.handleChangeForDatePicker(date, "expDate")}
                      disabled={this.state.productionRequisition.productionStageStatusId >= 3}
                    />
                    {/* <ValidationText error={this.state.validStateForMaterials.error.expDate} /> */}
                  </div>
                  <div className="input-grp w-full">
                    <label>Size</label>
                    <input
                      type="text"
                      id="size"
                      name="size"
                      autoComplete="off"
                      disabled
                      value={this.state.productionRequisition.size}
                      onChange={(event) => this.handleChange(event, "size")}
                    />
                    {/* <ValidationText error={this.state.validState.error.size} /> */}
                  </div>
                  <div className="input-grp w-full">
                    <label>Color</label>
                    <input
                      type="text"
                      id="colour"
                      name="colour"
                      autoComplete="off"
                      disabled
                      value={this.state.productionRequisition.colour}
                      onChange={(event) => this.handleChange(event, "colour")}
                    />
                  </div>
                  <div className="input-grp w-full col-start-1 col-span-3">
                    <label>Note</label>
                    <textarea
                      rows={2}
                      type="text"
                      id="productNote"
                      name="productNote"
                      autoComplete="off"
                      value={this.state.productionRequisition.productNote}
                      onChange={(event) => this.handleChange(event, "productNote")}
                    />
                  </div>
                  {/* <div className="input-grp w-full">
                    <label>Std. Batch Size</label>
                    <input
                      type="number"
                      id="stdBatchSize"
                      name="stdBatchSize"
                      autoComplete="off"
                      className="inputFocus"
                      disabled={this.state.productionRequisition
                        .productionStageStatusId >= 3}
                      value={this.state.productionRequisition.stdBatchSize}
                      onChange={(event) =>
                        this.handleChange(event, "stdBatchSize")
                      }
                    />
                    <ValidationText
                      error={this.state.validState.error.stdBatchSize}
                    />
                  </div> */}
                </div>
                <div className="btn-grp mb-4">
                  <button
                    className="add-btn"
                    disabled={this.state.productionRequisition
                      .productionStageStatusId >= 3 || this.state.isLoading}
                    onClick={() => {
                      this.generateSlipForProductionRequisition();
                    }}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Generate slip"}
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={() => this.openGridView()}
                    disabled={this.state.isLoading}
                  >
                    Cancel
                  </button>
                  {this.state.productionRequisition.productionStageStatusId >=
                    3 ? (
                    <button
                      className="print-btn"
                      onClick={() => this.setState({ setRMSlipModel: true })}
                    >
                      Print Slip
                    </button>
                  ) : null}
                </div>
              </div>

              <div className="itemList-table">
                <div className="table-container" style={{ height: 'calc(100vh - 388px)' }}>
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: "50%" }}>Material Name</td>
                        <td style={{ width: "15%" }}>Stage</td>
                        <td style={{ width: "15%" }}>Qty.</td>
                        <td style={{ width: "10%" }}>UOM</td>
                        <td style={{ width: "15%" }}>Stock</td>
                      </tr>
                    </thead>
                    {this.state.rmFormulaList &&
                      this.state.rmFormulaList.length > 0 ? (
                      this.state.rmFormulaList.map((item, key) => (
                        <tbody key={key}>
                          <tr
                            className={`hover:bg-[#dcebf24d] cursor-pointer ${Number(item.netQty) > Number(item.totalStock)
                              ? "text-red-600"
                              : ""
                              }`}
                            onClick={() => {
                              this.setState({
                                isQtyEditingKey: key,
                                updatedQty: item.netQty,
                              });
                              if (!this.state.isQtyEditing) {
                                this.setState({
                                  isQtyEditing: true,
                                });
                              }
                            }}
                          >
                            <td>{item.rmName}</td>
                            <td>{item.stageName}</td>
                            <td>
                              {this.state.isQtyEditing === true &&
                                this.state.productionRequisition
                                  .productionStageStatusId < 3 &&
                                key ===
                                (this.state.isQtyEditingKey >= 0
                                  ? this.state.isQtyEditingKey
                                  : null) ? (
                                <div class="flex items-center space-x-2">
                                  <input
                                    className="inputFocus"
                                    type="number"
                                    id="updatedQty"
                                    name="updatedQty"
                                    autoComplete="off"
                                    class="h-7 w-[80%] px-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
                                    value={this.state.updatedQty}
                                    onChange={(event) =>
                                      this.handleQtyChange(event)
                                    }
                                  />
                                  <button
                                    class="h-[28px] w-[28px] p-[5px] bg-sky-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                    onClick={() =>
                                      this.updateQtyForRMFormula(item, key)
                                    }
                                  >
                                    <FontAwesomeIcon icon={faCheck} className="w-full h-full" />
                                  </button>
                                </div>
                              ) : (
                                item.netQty
                              )}
                            </td>
                            <td>{item.rmUOM ? item.rmUOM : item.uom}</td>
                            <td>{item.totalStock}</td>
                          </tr>
                        </tbody>
                      ))
                    ) : (
                      <tbody className="validation-body">
                        <tr>
                          <td
                            colSpan={5}
                            style={{ textAlign: "center", fontSize: "16px" }}
                          >
                            No Records Found
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
                <p className="mb-[3px] text-[15px] font-medium text-[#474747] w-fit ml-auto" >
                  Total Solid Weight: {this.state.solidWeight}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Total Liquid Weight: {this.state.liquidWeight}
                </p>
              </div>
            </div>
          ) : null}
        </div>

        <ProductionRMSlipModel
          setRMSlipModel={this.state.setRMSlipModel}
          setModalOpen={this.setOpenModel.bind(this)}
          isPrintButtonHide={this.state.isPrintButtonHide}
          printData={this.printData.bind(this)}
          rmFormulaList={this.state.rmFormulaList}
          productionRequisition={this.state.productionRequisition}
          printRef={this.printRef}
          solidWeight={this.state.solidWeight}
          liquidWeight={this.state.liquidWeight}
        />
      </>
    );
  }
}

export default ProductionRequisition;
